import { useState,useEffect } from "react";

const typeSelection = 'LASTMONTH'

const useLocalStorage = ( ) => {

    const initState = {
        top: 5,
        lastMonth: 1
    }

    const item = localStorage.getItem(typeSelection);
    const hasItem = item !== null;

    const [ isLoading, setIsLoading] = useState(true);
    const [ itemState, setItemState] = useState(hasItem ? JSON.parse(item) : initState);

    const getItem = () => {

        const item = localStorage.getItem(typeSelection);
        if (item) {
            setItemState(JSON.parse(item));
        }
        setIsLoading(false);
    }

    const setItem = (data) => {
        localStorage.setItem(typeSelection, JSON.stringify(data));
    }

    useEffect(() => {
        getItem();
    }, []);

    return {
        itemState, 
        isLoading,
        getItem,
        setItem
    }
}

export default useLocalStorage;